import "@hotwired/turbo"
import { Application } from "@hotwired/stimulus"
import MoodListController from "./mood-list_controller.ts"
import DayController from "./days_controller.ts"
import TooltipController from "./tooltip_controller.ts"
import ToastController from "./toast_controller.ts"
import SocialToastController from "./social_toast_controller.ts"
import NoteController from "./note_controller.ts"
import ClipboardController from "./clipboard_controller.ts"
import ShareController from "./share_controller.ts"
import ThemeController from "./theme_controller.ts"
import TimezoneController from "./timezone_controller.ts"
import TabsController from "./tabs_controller.ts"
import NotificationController from "./notification_controller.ts"
import TodayController from "./today_controller.ts"
import InstallController from "./install_controller.ts"
import QRCodeController from "./qrcode_controller.ts"

declare global {
  interface Window {
    Stimulus: Application
  }
}

const application = Application.start()
// application.debug = true

window.Stimulus = application

const controllers = {
  "mood-list": MoodListController,
  "day": DayController,
  "tooltip": TooltipController,
  "toast": ToastController,
  "social-toast": SocialToastController,
  "note": NoteController,
  "clipboard": ClipboardController,
  "share": ShareController,
  "theme": ThemeController,
  "timezone": TimezoneController,
  "tabs": TabsController,
  "notification": NotificationController,
  "today": TodayController,
  "install": InstallController,
  "qrcode": QRCodeController,
}


Object.entries(controllers).forEach(([name, controller]) => {
  application.register(name, controller)
})
